import { ApprovalStatus, ProductSourceChangeStatus } from "@/graphql/codegen/graphql"

export const PENDING_CHANGES_PAGE_SIZE = 5

export const SOURCE_CHANGE_APPROVAL_STATUS_TO_LABEL: Record<ApprovalStatus, string> = {
  [ApprovalStatus.Approved]: "Approved",
  [ApprovalStatus.Pending]: "Pending",
  [ApprovalStatus.Rejected]: "Rejected",
  [ApprovalStatus.DoNotShip]: "Do Not Ship",
  [ApprovalStatus.Sampled]: "Sampled",
}

export const SOURCE_CHANGE_APPROVAL_STATUS_TO_CHIP_CLASS_NAME: Record<ApprovalStatus, string> = {
  [ApprovalStatus.Approved]: "bg-tertiary-green-100",
  [ApprovalStatus.Pending]: "bg-tertiary-orange-300",
  [ApprovalStatus.Rejected]: "bg-secondary-200",
  [ApprovalStatus.DoNotShip]: "bg-secondary-200",
  [ApprovalStatus.Sampled]: "bg-primary-200",
}

export const PRODUCT_SOURCE_CHANGE_STATUS_TO_LABEL: Record<ProductSourceChangeStatus, string> = {
  [ProductSourceChangeStatus.Pending]: "Pending",
  [ProductSourceChangeStatus.Approved]: "Approved",
  [ProductSourceChangeStatus.Rejected]: "Rejected",
  [ProductSourceChangeStatus.Superseded]: "Superseded",
}

export const PRODUCT_SOURCE_CHANGE_STATUS_TO_CHIP_CLASS_NAME: Record<ProductSourceChangeStatus, string> = {
  [ProductSourceChangeStatus.Approved]: "bg-tertiary-green-100",
  [ProductSourceChangeStatus.Pending]: "bg-tertiary-orange-300",
  [ProductSourceChangeStatus.Rejected]: "bg-secondary-200",
  [ProductSourceChangeStatus.Superseded]: "bg-tertiary-purple-300",
}
